var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 25,
    rx: 12.5,
    stroke: "#4E5574"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25C20.4036 25 26 19.6274 26 13C26 6.37258 20.4036 1 13.5 1C6.59644 1 1 6.37258 1 13C1 19.6274 6.59644 25 13.5 25Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2225 17.1739C25.725 15.8739 26 14.4678 26 13C26 11.5322 25.725 10.1261 25.2225 8.82611H1.77749C1.27505 10.1261 1 11.5322 1 13C1 14.4678 1.27505 15.8739 1.77749 17.1739L13.5 18.2174L25.2225 17.1739Z",
    fill: "#042B5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25C18.8745 25 23.4563 21.7435 25.2225 17.1739H1.77747C3.54363 21.7435 8.12541 25 13.5 25Z",
    fill: "#730015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia);
export default __webpack_public_path__ + "static/media/russia.49d749391903c0337f02454ab996bd28.svg";
export { ForwardRef as ReactComponent };